module.exports = __webpack_public_path__ + "img/hkecic_logo.708a26df.png";